
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Calendar } from 'lucide-react';
import ScheduleDemoDialog from '../ScheduleDemoDialog';

const ResellerHero: React.FC = () => {
  const [isScheduleDialogOpen, setIsScheduleDialogOpen] = useState(false);
  
  return (
    <section className="container mx-auto px-4 pt-20 text-center">
      <h1 className="text-5xl font-bold text-primary-blue mb-6">
        Launch Your Own Referral Platform Business
      </h1>
      <p className="text-xl text-gray-600 max-w-3xl mx-auto mb-10">
        Become a white-label referral program reseller and help businesses grow their customer base through powerful referral marketing.
      </p>
      <div className="flex flex-col sm:flex-row justify-center gap-4">
        <Link to="/business-reseller-order">
          <Button size="lg" className="bg-primary-blue text-white hover:bg-blue-700">
            Get Started
          </Button>
        </Link>
        <Button 
          size="lg" 
          variant="outline" 
          className="border-primary-blue text-primary-blue gap-2"
          onClick={() => setIsScheduleDialogOpen(true)}
        >
          <Calendar className="h-5 w-5" />
          Schedule Demo
        </Button>
      </div>
      
      {/* Schedule Demo Dialog */}
      <ScheduleDemoDialog 
        open={isScheduleDialogOpen} 
        onOpenChange={setIsScheduleDialogOpen} 
      />
    </section>
  );
};

export default ResellerHero;
